import { useMemo } from 'react'
import { useIntl } from 'react-intl'

export const useTruncatedPartnersErrorMessage = (partnerNames?: string[]) => {
  const intl = useIntl()

  const MAX_DISPLAY_PARTNER_NAMES_COUNT = 5

  const message = useMemo(() => {
    if (!partnerNames || partnerNames.length === 0) {
      return intl.formatMessage({ id: 'partnerWriteAccess.error.subtitleGeneric' })
    }

    if (partnerNames.length <= MAX_DISPLAY_PARTNER_NAMES_COUNT) {
      return intl.formatMessage(
        {
          id: 'partnerWriteAccess.error.subtitle',
        },
        {
          partnerNames: partnerNames.join(', '),
        }
      )
    }

    const displayedPartnerNames = partnerNames.slice(0, MAX_DISPLAY_PARTNER_NAMES_COUNT).join(', ')
    const numTruncated = partnerNames.length - MAX_DISPLAY_PARTNER_NAMES_COUNT

    return intl.formatMessage(
      {
        id: 'partnerWriteAccess.error.subtitleTruncated',
      },
      {
        partnerNames: displayedPartnerNames,
        remainingCount: numTruncated,
      }
    )
  }, [partnerNames, intl])

  return message
}
